import { colors } from '@maas-components/design-tokens';

export type Mode = 'dark' | 'light';

export type StyleProps = {
    mode: Mode;
};

export type ClassName = {
    header: {
        background: string;
        icon: string;
        text: string;
        searchField: {
            background: string;
            icon: string;
            text: string;
        };
    };
    profile: {
        companyName: string;
        userName: string;
        avatar: {
            background: string;
        };
    };
    sidebar: {
        icon: string;
        text: string;
        textHover: string;
        background: string;
    };
    menu: {
        icon: string;
        text: string;
        textTitle: string;
        background: string;
    };
};

const theme: Record<Mode, ClassName> = {
    dark: {
        header: {
            background: colors.neutral.c600,
            icon: colors.white,
            text: colors.white,
            searchField: {
                background: colors.white,
                icon: colors.neutral.c600,
                text: colors.neutral.c500,
            },
        },
        profile: {
            companyName: colors.blue.c100,
            userName: colors.white,
            avatar: {
                background: colors.white,
            },
        },
        sidebar: {
            icon: colors.white,
            text: colors.white,
            textHover: colors.transparency.light.alpha60,
            background: colors.neutral.c600,
        },
        menu: {
            icon: colors.white,
            text: colors.white,
            textTitle: colors.white,
            background: colors.neutral.c600,
        },
    },
    light: {
        header: {
            background: colors.white,
            icon: colors.neutral.c600,
            text: colors.neutral.c500,
            searchField: {
                background: colors.white,
                icon: colors.neutral.c600,
                text: colors.neutral.c500,
            },
        },
        profile: {
            companyName: colors.blue.c100,
            userName: colors.neutral.c600,
            avatar: {
                background: colors.neutral.c600,
            },
        },
        sidebar: {
            icon: colors.neutral.c500,
            text: colors.neutral.c600,
            textHover: colors.blue.c100,
            background: colors.white,
        },
        menu: {
            icon: colors.neutral.c700,
            text: colors.neutral.c700,
            textTitle: colors.neutral.c700,
            background: colors.white,
        },
    },
};

export default theme;
